import React, { useEffect, useState } from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { MessagesContainer, BotMessage, UserMessage, ContainerBoxMsg, BoxOptions, BtnOption, BotMessageConfirmation } from './styles'
import ConfirmationMessage from '../../Plugin/Chat/AnimationConfirmationMessage'
import logoTransparent from '../../assets/images/logotransparent.png'

export default function ModalMsg({ change, messages }) {
  const [arrayMsg, setArrayMsg] = useState()

  useEffect(() => {
    if (messages) {
      let parsedMessages = JSON.parse(messages)
      if (parsedMessages?.length > 0) setArrayMsg(parsedMessages)
    }
  }, [messages])

  function renderMessage(msg, index) {
    const isBotMessage = msg.fromMe
    let messageContent
    if (msg.tpConteudo === 'T') {
      const formattedContent = msg.conteudo.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      messageContent = (
        <ContainerBoxMsg key={index} type={isBotMessage ? 'bot' : 'user'}>
          {isBotMessage ? (
            <BotMessage>
              <p dangerouslySetInnerHTML={{ __html: formattedContent }} />
              <img src={logoTransparent} alt="Logo" />
            </BotMessage>
          ) : (
            <UserMessage>
              <p dangerouslySetInnerHTML={{ __html: formattedContent }} />
            </UserMessage>
          )}
        </ContainerBoxMsg>
      )
    } else if (msg.tpConteudo === 'O' && msg.fromMe == false) {
      messageContent = (
        <ContainerBoxMsg key={index} type={isBotMessage ? 'bot' : 'user'}>
          <BoxOptions>
            <BtnOption>
              <p>{msg.conteudo.label}</p>
            </BtnOption>
          </BoxOptions>
        </ContainerBoxMsg>
      )
    } else if (msg.tpConteudo === 'E') {
      messageContent = (
        <ContainerBoxMsg key={index} type="bot">
          <BotMessageConfirmation>
            <div>
              {msg.conteudo.split('\n').map((line, i) => (
                <span key={i}>
                  {line}
                  <br />
                </span>
              ))}
              <ConfirmationMessage isVisible={true} />
            </div>

            <img src={logoTransparent} alt="Logo" />
          </BotMessageConfirmation>
        </ContainerBoxMsg>
      )
    }

    return messageContent
  }

  return (
    <Modal isOpen={true} toggle={change}>
      <ModalHeader>Histórico de Mensagens</ModalHeader>
      <ModalBody>
        {arrayMsg ? (
          <MessagesContainer>
            {arrayMsg.map((d, index) => {
              return renderMessage(d, index)
            })}
          </MessagesContainer>
        ) : (
          <p>Sem histórico de mensagens</p>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={change}>
          Fechar
        </Button>
      </ModalFooter>
    </Modal>
  )
}
